import { ReactNode, lazy } from 'react'

const ContentUnsubscribePage = lazy(
  () => import('@/presentation/pages/content/content-unsubscribe/content-unsubscribe-page')
)

export const makeContentUnsubscribePage = (): ReactNode => {
  return <ContentUnsubscribePage />
}
